import * as Constants from '../../../constants';

import { faClose, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik } from "formik";
import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";

export default function ApplicationFormModal({ show, onHide, onSave, application }) {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [applications, setApplications] = useState([]);

    const validationSchema = Yup.object({

        title: Yup.string()
            .trim()
            .required("Informe o título"),

        custom: Yup.string()
            .required("Selecione uma opção"),

        status: Yup.string()
            .required("Selecione uma opção"),
    });

    const initialValues = {
        title: application?.title || "",
        custom: application?.custom || "0",
        status: application?.status || "0"
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");

                const headers = {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                };

                const [
                    usersRes,
                    applicationsRes,
                    applicationTypesRes,
                    statusTypesRes
                ] = await Promise.all([
                    fetch(Constants.APPLICATIONS_LIST, { signal, headers })

                ]);

                const applicationsJson = await applicationsRes.json();

                if (applicationsJson.status === "success")
                    setApplications(applicationsJson.data);
            } catch (error) {
                if (error.name === "AbortError") return;
                console.error("Erro:", error);
            } finally {
                setIsLoading(false);
            }

        };

        fetchData();

        return () => controller.abort();

    }, []);

    return (

        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {

                const data = application
                    ? { ...values, id: application.id }
                    : values;

                onSave(data);

                resetForm();
                onHide();

            }}
        >

            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (

                <Modal show={show} onHide={onHide} centered>

                    <Modal.Header closeButton className="bg-light">
                        <Modal.Title>
                            {application ? "Editar Aplicação" : "Cadastrar Aplicação"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Form noValidate>
                            {/* title */}

                            <Form.Group className="mb-3">

                                <Form.Label>Título</Form.Label>

                                <Form.Control
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.title && !!errors.title}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.title}
                                </Form.Control.Feedback>

                            </Form.Group>

                            {/* Custom */}

                            <Form.Group className="mb-3">
                                <Form.Label d-block>Tipo de Aplicação</Form.Label>

                                <div className="d-flex gap-3">
                                    <Form.Check
                                        type="radio"
                                        label={<span>Sob medida <br /> (Personalizada)</span>}
                                        name="custom"
                                        id="custom-tailor-made"
                                        value="1"
                                        checked={values.custom == 1}
                                        onChange={handleChange}
                                        isInvalid={touched.custom && !!errors.custom}
                                    />

                                    <Form.Check
                                        type="radio"
                                        label={<span>De Prateleira <br /> (Uso Geral)</span>}
                                        name="custom"
                                        id="custom-off-the-shelf"
                                        value="0"
                                        checked={values.custom == 0}
                                        onChange={handleChange}
                                        isInvalid={touched.custom && !!errors.custom}
                                    />
                                </div>

                                {touched.custom && errors.custom && (
                                    <div className="text-danger small mt-1">
                                        {errors.custom}
                                    </div>
                                )}
                            </Form.Group>


                            {/* Status */}

                            <Form.Group className="mb-3">
                                <Form.Label className="d-block">Status da Aplicação</Form.Label>

                                <div className="d-flex gap-3">
                                    <Form.Check
                                        type="radio"
                                        label={<span>Habilitada</span>}
                                        name="status"
                                        id="status-active"
                                        value="1"
                                        checked={values.status == 1}
                                        onChange={handleChange}
                                        isInvalid={touched.status && !!errors.status}
                                    />

                                    <Form.Check
                                        type="radio"
                                        label={<span>Desabilitada</span>}
                                        name="status"
                                        id="status-inactive"
                                        value="0"
                                        checked={values.status == 0}
                                        onChange={handleChange}
                                        isInvalid={touched.status && !!errors.status}
                                    />
                                </div>

                                {touched.status && errors.status && (
                                    <div className="text-danger small mt-1">
                                        {errors.status}
                                    </div>
                                )}
                            </Form.Group>

                        </Form>

                    </Modal.Body>


                    <Modal.Footer>

                        <Button variant="outline-secondary" onClick={onHide}>
                            <FontAwesomeIcon icon={faClose} /> Cancelar
                        </Button>

                        <Button variant="primary" onClick={handleSubmit}>
                            <FontAwesomeIcon icon={faFloppyDisk} /> Salvar
                        </Button>

                    </Modal.Footer>

                </Modal>

            )}

        </Formik>

    );

}
